import { jsx } from "react/jsx-runtime";
import { MRACPageContent } from "@zillow/zrs-military-rent-affordability-calculator";
import "react";
const BlockMilitaryRentCalculator = ({
  attrs
}) => {
  return /* @__PURE__ */ jsx(MRACPageContent, { ...attrs });
};
export {
  BlockMilitaryRentCalculator as default
};
